export default __webpack_public_path__ + "static/BG-main-2cb842e1cf66cefdc4a27748081774f1.png";